import React from 'react';
import { Bar } from 'react-chartjs-2';

const ReportChart = ({ reports }) => {
  const hourlyReportCounts = new Array(13).fill(0);
  const hourlyTotalCases = new Array(13).fill(0);

  reports.forEach((report) => {
    const dateParts = report.date.match(/(\d{1,2})\/(\d{1,2})\/(\d{4}), (\d{1,2}):(\d{2}):(\d{2}) (am|pm)/i);

    if (dateParts) {
      const hour = parseInt(dateParts[4]);
      const period = dateParts[7].toLowerCase();
      
      if ((hour >= 9 && period === 'am') || (hour === 12 && period === 'pm') || (hour <= 9 && period === 'pm')) {
        hourlyTotalCases[hour % 12] += 1;
        if (report.reportTime) {
          const reportTimeDate = new Date(report.reportTime);
          const reportTimeHour = reportTimeDate.getHours();
          hourlyReportCounts[reportTimeHour % 12] += 1;
        }
      }
    }
  });

  const hoursLabels = Array.from({ length: 13 }, (_, i) => {
    const hour = i + 9 >= 12 ? i - 3 : i + 9;
    return `${hour === 0 ? '12' : hour}:00`;
  });
  
  const data = {
    labels: hoursLabels,
    datasets: [
      {
        label: 'Number of Reports per Hour',
        backgroundColor: '#937dbc',
        maxBarThickness: 40,
        data: hourlyReportCounts,
      },
      {
        label: 'Total Cases per Hour',
        backgroundColor: '#6c475b',
        maxBarThickness: 40,
        data: hourlyTotalCases,
      },
    ],
  };

  const options = {
    scales: {
      y: {
        beginAtZero: true,
        stepSize: 1,
      },
    },
  };

  return (
    <div>
      <Bar data={data} options={options} />
    </div>
  );
};

export default ReportChart;
